// Static hex values for SVG attributes and JS logic that can't use CSS variables
export const rawBlue1 = '#4A90E2';
export const rawRed3 = '#fd6681';
export const rawLightGray2 = '#A1ACC3';
